import { MetaFunction } from "@remix-run/react";
import type { LoaderFunctionArgs } from "@shopify/remix-oxygen";
import Route from "~/components/routes/Route";
import { loader as loaderRoute, meta as metaRoute } from "~/data/loaders/route";

export const meta: MetaFunction<typeof loader> = (args) => {
  return metaRoute(args);
};

export async function loader(args: LoaderFunctionArgs) {
  return loaderRoute(args);
}

export default function Component() {
  return <Route />;
}
